import React from 'react';

import ContentGazetters from './Gazetters';
import ContentAnnotations from './Annotations';

const ChooseContent = ({
    typeAnnotations = 'annotate',
    selectedType,
    textLetter,
    annotations,
    gazetters,
    addNewGazetter,
    withChildren,
    predictorData,
    showUsefulLines,
    lineScoreData,
}) => {
    if (typeAnnotations === 'annotate') {
        return (
            <ContentGazetters
                withChildren={withChildren}
                gazetters={gazetters}
                addNewGazetter={addNewGazetter}
                textLetter={textLetter}
                predictorData={predictorData}
                showUsefulLines={showUsefulLines}
                lineScoreData={lineScoreData}
            />
        );
    }

    return (
        <ContentAnnotations
            selectedType={selectedType}
            typeAnnotations={typeAnnotations}
            annotations={annotations}
            textLetter={textLetter}
            predictorData={predictorData}
            showUsefulLines={showUsefulLines}
            lineScoreData={lineScoreData}
        />
    );
};

export default ChooseContent;



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Content/ChooseContent.jsx